module.exports = __webpack_public_path__ + "img/leads.c7c1a1f1.svg";